import { fetchAPI } from '@/shared/lib/api/client';
import type { CurrencyCode } from '@/shared/lib/currency';

import { PaginatedHistory, RollsRound, RoundDetail } from '../model/types';

export const rollsApi = {
  async placeBet(amount: number, currency: CurrencyCode, giftId?: string): Promise<RollsRound> {
    // The backend treats giftId and amount as mutually exclusive: a gift stake
    // sends only `giftId` (camelCase) and the server values it from the gift.
    const body = giftId ? { giftId } : { amount, currency };
    const { data } = await fetchAPI.post<RollsRound>('/rolls/bet', body);
    return data;
  },

  async getCurrentRound(): Promise<RollsRound> {
    const { data } = await fetchAPI.get<RollsRound>('/rolls/current-round');
    return data;
  },

  async getHistory(page = 1, pageSize = 10, search = ''): Promise<PaginatedHistory> {
    const { data } = await fetchAPI.get<PaginatedHistory>('/rolls/history', {
      params: { page, page_size: pageSize, search },
    });
    return data;
  },

  async getRoundDetail(roundId: string): Promise<RoundDetail> {
    const { data } = await fetchAPI.get<RoundDetail>(`/rolls/round/${roundId}`);
    return data;
  },
};
